module.exports = __webpack_public_path__ + "img/layout_tree_left_right_icon.16ccc8e6.svg";